import moment from "../utils/moment";
import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Field from "./Field";

interface InputProps {
  label?: React.ReactNode;
  value?: string;
  border?: string;
  margin?: string;
  placeholder?: string;
  svg?: React.ReactNode;
  icon?: string;
  name?: string;
  onChange?: (e: any) => void;
  showIcon?: boolean;
  hint?: string;
  error?: string;
  required?: boolean;
  maxDate?: Date;
}
const InputDate: React.FC<InputProps> = ({
  label,
  value,
  placeholder,
  svg,
  border,
  margin,
  icon = "bi-calendar3",
  name,
  onChange,
  showIcon = false,
  hint = "",
  error,
  required,
  maxDate = new Date(),
  ...rest
}) => {
  const minDateLimit = new Date("1950-01-01");
  return (
    <Field
      label={label}
      margin={margin}
      icon={showIcon && !svg ? icon : undefined}
      iconNode={showIcon ? svg : undefined}
      hint={hint}
      error={error}
      required={required}
    >
      <DatePicker
        isClearable={false}
        className={`form-control ${border || ""}`}
        name={name}
        placeholderText={placeholder}
        selected={value ? new Date(value) : null}
        onChange={(date: any) =>
          onChange
            ? onChange({
                target: {
                  name: name,
                  value: moment(date).toISOString(),
                },
              })
            : null
        }
        showMonthDropdown
        showYearDropdown
        scrollableYearDropdown
        minDate={minDateLimit}
        maxDate={maxDate}
        yearDropdownItemNumber={100}
        autoComplete="off"
        autoFocus={false}
        {...rest}
      />
    </Field>
  );
};

export default InputDate;
